export class FetchUserWorkshopDataAction {
  static readonly type = '[My Workshop] Fetch User Workshop Data';

  constructor() {
  }
}
